import { GraphQLClient } from "graphql-request";

import { ProgramContentTitlesDocument } from "./graphql";

export const hygraphClient = new GraphQLClient(
  "https://d2wc1n1dtl1vi2.cloudfront.net/",
  {
    fetch,
    method: "GET",
    jsonSerializer: {
      parse: JSON.parse,
      stringify: JSON.stringify,
    },
  },
);

const parseContentId = (contentId: string) => {
  const [programContentId, subContentId] = contentId
    .replace("content", "")
    .split("s");
  return {
    programContentId: parseInt(programContentId),
    subContentId: parseInt(subContentId ?? "0"),
  };
};

export async function getProgramContentTitles() {
  const first100Promise = hygraphClient
    .request(ProgramContentTitlesDocument, { first: 100 })
    .then((data) => data.programContents);

  const second100Promise = hygraphClient
    .request(ProgramContentTitlesDocument, { first: 100, skip: 100 })
    .then((data) => data.programContents);

  return Promise.all([first100Promise, second100Promise]).then(
    ([first100, second100]) => {
      return Object.fromEntries(
        [...first100, ...second100]
          .sort((a, b) => {
            const aParsed = parseContentId(a.programContentId);
            const bParsed = parseContentId(b.programContentId);
            return (
              aParsed.programContentId - bParsed.programContentId ||
              aParsed.subContentId - bParsed.subContentId
            );
          })
          .map((pc) => [pc.programContentId, pc.title]),
      );
    },
  );
}
